/** 网站信息 */
export const BEIAN_TEXT = "浙ICP备2021026792号";
export const BEIAN_URL = "https://beian.miit.gov.cn/";
export const TZB_URL = "https://tzb.release.zgjmdbw.com";
export const NAV_LINKS = [
  { label: "首页", href: "/" },
  { label: "产品服务", href: "/product" },
  { label: "在线申请", href: TZB_URL },
  { label: "保函验证", href: "/verification" },
  { label: "关于我们", href: "/about" },
];
/** 企业信息 */
export const COMPANY_NAME = "浙江京保科技有限公司";
export const COMPANY_ADDRESS =
  "浙江省温州市鹿城区南汇街道万源路356号万麓园2幢鹿城国际大厦507室";
export const COMPANY_PHONE = "0577-88927182";
export const COMPANY_EMAIL = "support@zgjmdbw.com";
export const COMPANY_MAP_URL = `https://ditu.amap.com/search?query=${encodeURIComponent(
  COMPANY_ADDRESS
)}`;
export const SERVICE_PHONES = ["0577-88927182", "13616621994"];
/** 项目信息 */
export const SERVICE_CARD_TEXTS: { [key: string]: string } = {
  投标保函:
    "投标担保是指由担保人为投标人向招标人提供的，保证投标人按照招标文件的规定参加招标活动的担保。投标人在投标有效期内撤回投标文件，或中标后不签署工程建设合同的，由担保人按照约定履行担保责任。",
  履约保函:
    "由保证人为承包商向业主提供的保证承包商履行工程建设合同约定义务的担保。",
  预付款保函:
    "业主支付给承包人或供应商合同约定的预付款时， 由承包人或供应商向业主提交的担保，保证其按照合同约定正确和合理地为合同目的使用预付款， 以及按合同约定配合业主全额扣回所预付的金额，不将预付款挪作他用。",
  工程款支付保函:
    "为保证业主履行工程合同约定的工程款支付义务，由担保人为业主向承包商提供的，保证业主支付工程款的担保。业主在签订工程建设合同的同时，应当向承包商提交业主工程款支付担保。",
  质量保函:
    "由担保人为承包商向业主提供的，保证承包商在工程质量保修担保期内承担质量保修责任的担保。",
  农民工工资支付保函:
    "农民工工资支付保函是指担保人对业主或承包商支付民工工资义务的担保。一旦业主或承包商违约，不能按时、足额支付民工工资，担保人将代为支付(之后担保人再向业主或承包商追偿)，以保障(农)民工的合法权益。",
  售电保函:
    "由银行应申请人要求，为售电公司向电力交易中心开立的，保证该售电公司履约市场化电量结算义务的书面信用担保凭证",
};
export const SERVICES_KEYS = Object.keys(SERVICE_CARD_TEXTS);
export const PRODUCT_LIST = [SERVICES_KEYS.slice(0, 4), SERVICES_KEYS.slice(4)];
export const SERVICE_TABS = [
  {
    label: "工程类保函",
    cards: [
      "投标保函",
      "履约保函",
      "预付款保函",
      "工程款支付保函",
      "质量保函",
      "农民工工资支付保函",
    ],
  },
  { label: "政府采购保函", cards: [] },
  { label: "售电保函", cards: ["售电保函"] },
  { label: "海关文旅保函", cards: [] },
  { label: "法院诉讼保函", cards: [] },
];

/** 内容常量 */
export const TECHNOLOGY_DESC =
  "在线申请、电子签章、支付、出单、退保、理赔、发票申请等全流程线上化。";
export const PLATFORM_INTRO = `投中宝数字保函平台以“金融+科技”深度融合为核心，为企业、金融机构及政府机构提供安全、高效、透明的数字化保函服务。运用区块链、人工智能、大数据技术，为企业提供全流程线上化的投标、履约、预付款等保函服务；助力用户实现业务办理“零跑腿、秒审批、低成本”。\n\n平台联合银行、保险及权威CA机构，确保保函具备法律效力与金融安全，并通过智能风控引擎与OCR技术实现“分钟级”审批，显著提升效率。区块链存证保障交易数据不可篡改与可追溯，助力构建数字化商业生态。平台致力于通过技术创新推动普惠金融，为企业降本增效、为金融机构赋能风控、为监管提供可信支持，成为数字保函领域的创新标杆。`;
export const INTRO_TEXT =
  "自成立以来，已为多地多领域提供电子保函解决方案，替代传统保证金，大幅提高企业办事效率，为企业减负，激发市场活力。同时持续开拓政务、担保电子化应用场景，通过打造本地化金融服务平台，解决了当地企业一系列金融需求，帮助当地金融机构借助平台突破传统业务模式，更好惠及各方市场主体。";
export const TAGS = ["权威验证", "实时查询", "安全可靠"];
export const NAVS = [
  { name: "企业概况", index: 0 },
  //   {name:"企业文化",index:1},
  //   {name:"服务优势",index:2},
  { name: "公司资质", index: 3 },
  { name: "平台介绍", index: 4 },
  //   {name:"整体技术方案",index:5},
  { name: "产品优势", index: 6 },
  { name: "联系我们", index: 7 },
];
export const PRODUCT_ADVANTAGES = [
  {
    icon: "/assets/about/k-1.png",
    title: "在线一键申请",
    content: "全程在线办理，手续简单便津，节省办理成本",
  },
  {
    icon: "/assets/about/k-2.png",
    title: "存证保真",
    content: "区块链结合数字证书应用，全流程节省办理成本",
  },
  {
    icon: "/assets/about/k-3.png",
    title: "电子签章&电子发票",
    content: "实现无纸化办公，同时保证了电子文件的不可篡改和不可否认",
  },
  {
    icon: "/assets/about/k-4.png",
    title: "高效出函",
    content: "即时申请，实时审核，最快3秒出函",
  },
  {
    icon: "/assets/about/k-5.png",
    title: "简化操作流程",
    content: "在线申请、审核、支付、出单、退保、理赔、发票申请等全流程线上化",
  },
  {
    icon: "/assets/about/k-6.png",
    title: "线上出函",
    content: "保函手续便捷，迅速省去中间环节，提升出函效率",
  },
];
export const SERVICE_ITEMS = [
  {
    title: "专业团队",
    content:
      "公司研发团队核心技术人员占比超80%，均从业互联网金融十数年，精通金融系统开发及数据库建设",
  },
  {
    title: "安全保障",
    content:
      "端到端加密传输；权限隔离管控；关键操作可追溯；实时风控监测；灾备备份确保快速恢复。",
  },
  {
    title: "品质服务",
    content:
      "京保科技拥有互联网金融及金融系统建设专业团队，提供技术咨询、培训、平台开发与运营保障等服务。",
  },
];
export const CULTURE_CARDS = [
  {
    title: "企业使命",
    content: "让技术驱动金融服务创新，打造值得信赖的数字保函平台。",
  },
  {
    title: "企业愿景",
    content: "成为数字金融时代保函服务的创新标杆与首选平台。",
  },
  {
    title: "经营理念",
    content: "以专业立足，以高效取胜，以合规保障，以共赢发展。",
  },
];
export const QUALIFICATIONS = [
  {
    title1: "中国金融科技创",
    title2: "新示范企业",
  },
  {
    title1: "中国金融科技行业信用",
    title2: "AAA级单位",
  },
  {
    title1: "质量管理体系认证",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "电子保函保密系统",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "电子保函操作系统平台",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "电子保函开具方法智能软件",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "电子保函平台会员充值管理系统",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "基于小程序的电子保函验证方法系统",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "电子保函营销系统",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "电子保函基本户识别系统",
  },
  {
    title1: "计算机软件著作权登记证书",
    subtitle: "客户管理系统",
  },
];
export const FIXED_TAGS = ["出函快", "材料简", "费用低"];
export const PRODUCT_CARDS = [
  {
    icon: "",
    title: "担保金额",
    desc: "根据招标文件规定，担保金额一般按照工程总造价的2%缴交，不超过80万元。",
  },
  {
    icon: "",
    title: "担保期限",
    desc: "由招标人在招标文件中规定或者在工程建设合同中约定，一般是根据招标有效期来设置投标保函的期限，最短10天，一般为90天。最长不超过180天。",
  },
  {
    icon: "",
    title: "产品优势",
    desc: "可线上办理，极速出函，满足企业时效要求。不需押现金，不占用银行授信额度，真正为企业减轻负担。",
  },
  {
    icon: "",
    title: "应用领域",
    desc: "工程建设、采购供货招投标环节可进行申请，涵盖工程项目投标、供货采购项目投标、服务类项目投标、资产/矿产/土地等项目投标等场景。",
  },
];
export const ADVANTAGE_CARDS = [
  {
    title: "快速出函",
    desc: "在线申请，实时出函，快速响应企业需求。",
  },
  {
    title: "业务齐全",
    desc: "保函种类齐全，项目各类保函可一站式申请。",
  },
  {
    title: "金融安全",
    desc: "与各大银行机构合作，为资金、理赔安全护航。",
  },
  {
    title: "客户服务",
    desc: "全天候人工客服，快速协助解决各种问题。",
  },
];
export const INTRO_STATS = [
  { num: "10", unit: "年", label: "研发经验" },
  { num: "48", unit: "+", label: "服务中心" },
  { num: "100", unit: "+", label: "专业团队" },
  { num: "千亿", unit: "", label: "企业减负" },
];

export const CITY_GROUPS = [
  {
    province: "浙江省",
    cities: "杭州市、宁波市、温州市、台州市、衢州市、湖州市",
  },
  {
    province: "江苏省",
    cities: "宿迁市、盐城市、常州市、镇江市、淮安市、泰州市",
  },
  { province: "山东省", cities: "济南市、青岛市" },
  { province: "福建省", cities: "南平市" },
  { province: "山西省", cities: "大同市" },
  { province: "新疆", cities: "阿勒泰" },
  { province: "内蒙古", cities: "阿拉善盟" },
  { province: "安徽省", cities: "安庆市" },
  { province: "陕西省", cities: "西咸新区、延安市" },
];
export const PROVINCES = [
  "浙江省",
  "杭州市",
  "宁波市",
  "温州市",
  "绍兴市",
  "湖州市",
  "嘉兴市",
  "金华市",
  "衢州市",
  "台州市",
  "玉环市",
  "温岭市",
  "丽水市",
  "舟山市",
];
export const PARTNER_TABS = [
  {
    key: "tech",
    label: "科技企业",
    list: ["工保网", "擎洲软件", "品茗", "新点", "融都科技", "广联达"],
  },
  {
    key: "finance",
    label: "金融机构",
    list: ["金为担保", "平安银行", "建设银行", "金茂担保"],
  },
];

const TYPE_TEMPLATE = {
  投标保函: {
    describe:
      "根据招标文件和指定格式出具商业投标保函。出函时间10分钟-1个工作日。",
    files: {
      company: ["营业执照"],
      project: ["招标文件"],
    },
  },
  工程款支付保函: {
    describe: "申请企业未被列入失信人，被执行人名单",
    files: {
      company: ["营业执照", "开户许可证", "法人身份证复印件"],
      project: [
        "建设工程施工合同",
        "土地款缴款凭证（如有）",
        "提供的“进度产值申报表”或“工程款支付报审表”或“项目结算单”（如有）",
        "现场照片（如已开工）",
      ],
    },
  },
  质量保函: {
    describe: "申请企业未被列入失信人名单，原则上不存在被执行案件",
    files: {
      company: ["营业执照", "开户许可证", "法人身份证复印件"],
      project: [
        "建设工程施工合同（后附质量保修书）",
        "竣工验收报告",
        "财政性投资建设项目审核意见书（如是财政预算项目）",
        "现场照片（如是房建项目）",
      ],
    },
  },
  履约与预付款支付保函: {
    describe: "申请企业未被列入失信人名单，原则上不存在被执行案件",

    files: {
      company: ["营业执照", "开户许可证", "法人身份证复印件"],
      project: ["招标文件", "中标通知书", "建设工程施工合同"],
    },
  },
  农民工工资支付保函: {
    describe: "申请企业未被列入失信人名单，原则上不存在被执行案件",

    files: {
      company: ["营业执照", "开户许可证", "法人身份证复印件"],
      project: ["建设工程施工合同", "施工许可证", "农民工工资保证金办理通知书"],
    },
  },
  售电保函: {
    describe: "申请企业未被列入失信人名单，原则上不存在被执行案件",

    files: {
      company: [
        "营业执照",
        "开户许可证",
        "法人身份证复印件",
        "企业章程（最近版）",
        "结算单",
        "信用报告",
        "准入公示",
        "管理办法文件",
        "高管职称文件",
        "下游合同及用户清单",
      ],
      project: [],
    },
  },
};
const BANK_TEMPLATE = {
  平安银行: {
    name: "平安银行",
    describe: [
      {
        icon: "",
        name: "授信申请核额",
        content:
          "授信资料（见后“所需材料”清单）加盖公章后邮寄银行客户经理。已开通平安银行网银的，可通过企业网银线上上传资料并发起授信申请。最快当天完成核额。",
      },
      {
        icon: "",
        name: "开立结算户",
        content:
          "可远程方式开立账户：申请人通过扫描二维码完成远程视频核验后，到附近的平安银行任意网点提交开户资料（包括开户申请书、公司营业执照、法人身份证、印鉴卡等，具体以柜台为准）申请开户。",
      },
      {
        icon: "",
        name: "存入保证金",
        content:
          "在实际开立保函当天，按照保函的金额，在开立的平安银行结算户中存入等额资金（100%保证金）。具体保证金利率及手续费率详询平台人员或银行客户经理。",
      },
      {
        icon: "",
        name: "项目材料",
        content:
          "须提供与受益人签署的合同。如对保函文本有特定要求，需提前发文本给银行客户经理。",
      },
    ],
    files: {
      company: [
        "对公客户授信业务申请书（银行提供模板）",
        "营业执照复印件",
        "法定代表人或负责人及实际控制人身份证复印件",
        "中征码复印件及查询信息、征信授权书（银行提供模板）",
        "上两年度财务报表",
        "公司章程，决议（如有，如公司章程中规定对外融资需经对应表决权通过，则需提供对应决议）",
      ],
      project: ["招标文件"],
    },
  },
  建设银行: {
    name: "建设银行",
    describe: [
      "保函受益人为政府机关、国有企业、具有较强实力上市公司及项下子公司；",
      "项目或申请方一头归属于浙江省、江苏省、福建省、上海市；",
      "申请方必须为二级资质（含）以上企业；申请方如为总承包一级资质（含）以上企业，项目所在区域不受限制；",
      "申请企业如有被执行案件，须提供案件完结文件或双方已签订的偿还协议等； ",
      "申请企业征信报告中授信余额如有关注，能够阐述清楚原因，并且申请企业经营情况良好，可以准入；",
      "涉及金融纠纷被执行及诉讼案件不予准入",
    ],
    files: {
      company: [
        "营业执照（纸质盖章版）",
        "开户许可证（电子盖章版）",
        "法人身份证复印件（纸质盖章版）",
        "企业简介（电子盖章版）",
        "企业章程（电子盖章版）",
        "近期一年财务报表、近期一个月财务报表（电子盖章版）",
        "企业信用报告（电子版）  ",
        "企业资质证书、安全生产许可证 （电子盖章版）  ",
        "工程在建清单",
      ],
      project: ["招标文件", "中标通知书", "施工合同（均为电子盖章版）"],
    },
  },
};
export const SERVICES_CONTENTS = {
  投标保函: [
    {
      ...TYPE_TEMPLATE["投标保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/t-jm.png",
    },
    {
      ...TYPE_TEMPLATE["投标保函"],
      name: "浙江金为工程担保有限公司",
      image: "/assets/product-image/t-jw.png",
    },
  ],
  预付款保函: [
    { ...BANK_TEMPLATE["平安银行"], image: "" },
    {
      ...TYPE_TEMPLATE["履约与预付款支付保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/y-jm.png",
    },
    {
      ...TYPE_TEMPLATE["履约与预付款支付保函"],
      name: "浙江金为工程担保有限公司",
      image: "",
    },
  ],
  履约保函: [
    { ...BANK_TEMPLATE["平安银行"], image: "" },
    { ...BANK_TEMPLATE["建设银行"], image: "/assets/product-image/l-js.png" },
    {
      ...TYPE_TEMPLATE["履约与预付款支付保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/l-jm.png",
    },
    {
      ...TYPE_TEMPLATE["履约与预付款支付保函"],
      name: "浙江金为工程担保有限公司",
      image: "",
    },
  ],
  工程款支付保函: [
    {
      ...TYPE_TEMPLATE["工程款支付保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/g-jm.png",
    },
    {
      ...TYPE_TEMPLATE["工程款支付保函"],
      name: "浙江金为工程担保有限公司",
      image: "",
    },
  ],
  质量保函: [
    { ...BANK_TEMPLATE["平安银行"], image: "" },
    {
      ...TYPE_TEMPLATE["质量保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/z-jm.png",
    },
    {
      ...TYPE_TEMPLATE["质量保函"],
      name: "浙江金为工程担保有限公司",
      image: "",
    },
  ],
  农民工工资支付保函: [
    { ...BANK_TEMPLATE["平安银行"], image: "" },
    {
      ...TYPE_TEMPLATE["农民工工资支付保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/n-jm.png",
    },
    {
      ...TYPE_TEMPLATE["农民工工资支付保函"],
      name: "浙江金为工程担保有限公司",
      image: "",
    },
  ],
  售电保函: [
    {
      ...TYPE_TEMPLATE["售电保函"],
      name: "温州市金茂融资担保有限公司",
      image: "/assets/product-image/s-jm.png",
    },
    {
      ...TYPE_TEMPLATE["售电保函"],
      name: "浙江金为工程担保有限公司",
      image: "",
    },
  ],
};
